<template>
  <div id="app">
    <home />
  </div>
</template>
<script>
import home from "./components/home.vue";
export default {
  components: {
    home,
  },
  data() {
    return {};
  },
  computed: {
    arr() {
      const res = [];
      for (let index = 0; index < 1000; index++) {
        res.push({ name: index });
      }
      return res;
    },
  },
};
</script>
<style>
#app {
  height: 100vh;
  background-color: #f0f4f9;
}
.error {
  background-color: #383838;
  border-radius: 50px;
  padding: 8px;
  border: 1px solid #ff6b6b;
}
p {
  margin: 0;
}
/* .el-message--error .el-message__content {
  color: #fff !important;
} */
</style>
